export const getPressReleaseLink = (companyId: string, prId: string) => {
    return `/companies/${companyId}/press-releases/${prId}`
}
